<template>
	<div class = "whole-viewport">
		<NavBar :groupInfo="groupInfo" :demoInfo="demoInfo" active="publications" />
		<v-layout row wrap style = "background:url('https://ws2.sinaimg.cn/large/006Xmmmggy1g6s2iiwwqbj33340nmkjl.jpg');" class = "elevation-1">
            <v-flex xs12 class="text-xs-center pt-4 ">
                <div class = "mb-2" :style = "{color:this.$color.primary,fontSize:5.0 + 'rem',fontFamily:'Calluns !important'}">Publications</div>
                <div class = "display-1 mb-4" style="color:grey">文章岂能尽心意 下笔已是第二乘</div>
            </v-flex>
        </v-layout>
        <v-layout row wrap class="pt-3 publication-container">
            <v-flex xs12 sm12 md10 offset-md1 class="text-xs-left legend-row">
                <div v-for="(group,gid) in groupInfo.slice(0,3)" :key="gid" class="legend-item">
                    <v-btn :key="'l1-'+gid" :color="group.logan" fab v-on="on" small></v-btn>
                    <span class="subheading" :key="'t1-'+gid">{{group.name}}</span>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap class="pt-2 publication-container">
            <v-flex xs12 sm12 md10 offset-md1 class="text-xs-left legend-row">
                 <div v-for="(group,gid) in groupInfo.slice(3)" :key="gid" class="legend-item">
                    <v-btn :key="'l2-'+gid" :color="group.logan" fab v-on="on" small></v-btn>    
                    <span class="subheading" :key="'t2-'+gid">{{group.name}}</span>
                 </div>
            </v-flex>
        </v-layout>
        <v-divider class = "mt-3"></v-divider>
        <v-layout row wrap class = "pt-2 publication-container">
            <v-flex xs12 sm12 md10 offset-md1 class = "text-xs-center">
                <v-list two-line expand class = "limit__height__class publication-list" style = "height:100px;" >
                    <template v-for="(item, index) in publications"  id = "paper-title">
                        <v-list-tile :key="item.title" ripple class = "mx-5">
                            <v-list-tile-content v-bind:id="item.name.replaceAll(' ', '')" style = "height:auto;">
                                <v-list-tile-title class = "mt-3 py-1 publication-title" :style="{height:'auto',fontSize:1.7 + 'rem',color:$color.activate}"  >
                                    {{ item.name }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title class = "text--primary my-1 " :style="{height:'auto',fontSize:1.3 + 'rem',color:$color.primary}">
                                    <template  v-for="(author,au_id) in item.authors" >
                                        <span style="mr-2" :key="au_id">
                                            {{ author + getAuthorSeparator(au_id, item.authors) }}
                                        </span>
                                    </template>
                                    </v-list-tile-sub-title>
                                <v-list-tile-sub-title class = "pb-1" :style="{height:'auto',fontSize:1.1 + 'rem',color:$color.primary}">{{ item.conference + ' ' + item.year }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title class = "mb-3 pb-1" :style="{height:'auto',fontSize:1.1 + 'rem',color:$color.primary}">
                                    <div class = "v-btn__content" style="justify-content:left;">
                                        <v-icon>link</v-icon>
                                        <template v-for="(rl,rl_id) in resourceList" >
                                            <a v-if="item[rl] != ''" :key="'link-' + rl_id" class = "ml-1" :href="item[rl]" :style="{color:$color.activate} ">
                                                {{rl}}
                                            </a>
                                            <span v-else :key="'nolink-' + rl_id" class = "ml-1"> 
                                                {{rl}}
                                            </span>
                                            <span :key="'sep-' + rl_id" class = "ml-1">
                                                {{ getResourceSeparator(rl_id, resourceList) }}
                                            </span>
                                        </template>
                                    </div>
                                    
                                    
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                            </v-list-tile-action>
                            <template v-for="(group,gid) in item.color">
                                <v-tooltip top :key="index * gid" attach = "#paper-title" class = "limit-logan-offset">
                                    <template v-slot:activator="{on}">
                                        <v-btn :color="group[1]" fab v-on="on" style="height:25px;width:25px;"></v-btn>
                                    </template>
                                    <span>{{group[0]}}</span>
                                </v-tooltip>   
                            </template>
                        </v-list-tile>
                        <v-divider v-if="index + 1 < publications.length" :key="index"></v-divider>
                    </template>
                </v-list>
            </v-flex>
            <v-flex xs2></v-flex>
        </v-layout>

	</div>
</template>

<script>
import NavBar from './NavBar'
export default {
  name: 'Publications',
  components:{NavBar},
  data() {
    return {
        resourceList:["pdf","code","demo","video"],
        publications:[{name:"",authors:[],year:"",conference:"",bibtex:"",pdf:"",code:"",demo:"",color:[],video:""}],
        sscolor:"#575757",
        groupInfo:[{name:"",
					introPic:"",
					intro:"",
					description:"",
					logan:""
                    }],
        demoInfo:[
            {name:"Interactive Rainbow Score", address:"/demo/IRS"}
        ]
    }
  },
  mounted() {
      this.getPublicationInfo()
      
  },
  props: {
    msg: String
  },
  methods: {
    switchToPage:function(url) {
		window.location.href=url
	},
    getAuthorSeparator: function(au_id, authors) {
      return parseInt(au_id) + 1 < Object.keys(authors).length ? ', ' : ' '
    },
    getResourceSeparator: function(rl_id, resourceList) {
      return parseInt(rl_id) + 1 < Object.keys(resourceList).length ? ' | ' : ' '
    },
    getPublicationInfo:async function() {
        let that = this
        await this.$axios.get("/group/id/list").then(function(res) {
			that.groupInfo = []
			for(let i in res.data) {
				that.groupInfo.push({
					name:res.data[i].name,
					intro:res.data[i].intro,
					introPic:res.data[i].picture,
					description:res.data[i].keywords,
					logan:res.data[i].color
				})
            }
		}).catch(function() {
			// Error loading group info
		})
        await this.$axios.get("/publication/id/list").then(function(res) {
            that.publications = res.data
            for(let i in that.publications) {
                that.publications[i].groups = that.groupInfo
                that.publications[i].bibtex = "@/" + that.publications[i].bibtex
            }
            that.publications.reverse()
		}).catch(function() {
			// Error loading publications
		})
    }
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.limit__height__class .v-list__tile {
    height: inherit !important;
}
.limit-logan-offset .v-tooltip__content {
    top:1px !important;
}
.publication-title {
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    text-overflow: unset !important;
    overflow: visible !important;
    line-height: 1.4 !important;
}
.publication-list .v-list__tile__content {
    overflow: visible !important;
    flex: 1 1 auto !important;
    min-width: 0 !important;
    max-width: calc(100% - 80px) !important;
}
.publication-list .v-list__tile {
    align-items: flex-start !important;
}
.publication-list .v-list__tile__action {
    flex-shrink: 0 !important;
    min-width: auto !important;
}
.publication-container {
    padding-left: 12px;
    padding-right: 12px;
}
.legend-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 12px;
    align-items: center;
}
.legend-item {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
}
.publication-list .v-list__tile {
    margin-left: 0 !important;
    margin-right: 0 !important;
}
@media (max-width: 960px) {
    .publication-container {
        padding-left: 10px;
        padding-right: 10px;
    }
    .legend-row {
        flex-direction: column;
        align-items: flex-start;
    }
    .publication-list .v-list__tile.mx-5,
    .publication-list .v-list__tile[class*="mx-5"] {
        margin-left: 8px !important;
        margin-right: 8px !important;
    }
    .publication-list .v-list__tile {
        margin-left: 8px !important;
        margin-right: 8px !important;
        padding-left: 8px !important;
        padding-right: 8px !important;
    }
    .publication-list .v-list__tile__content {
        max-width: calc(100% - 60px) !important;
    }
    .publication-list .v-list__tile .v-list__tile__action {
        min-width: 40px !important;
        padding-left: 8px !important;
        padding-right: 4px !important;
        flex-shrink: 0 !important;
    }
}
@media (max-width: 600px) {
    .publication-container {
        padding-left: 2px;
        padding-right: 2px;
    }
    .publication-list .v-list__tile.mx-5,
    .publication-list .v-list__tile[class*="mx-5"],
    .publication-list [class*="mx-5"],
    .publication-list div[role="listitem"].mx-5,
    .publication-list div[role="listitem"][class*="mx-5"] {
        margin-left: 2px !important;
        margin-right: 2px !important;
    }
    .publication-list .v-list__tile,
    .publication-list div[role="listitem"] {
        margin-left: 2px !important;
        margin-right: 2px !important;
        padding-left: 2px !important;
        padding-right: 2px !important;
    }
    .publication-list .v-list__tile__content {
        max-width: calc(100% - 50px) !important;
        padding-right: 2px !important;
    }
    .publication-list .v-list__tile .v-list__tile__action {
        min-width: 32px !important;
        padding-left: 2px !important;
        padding-right: 1px !important;
        flex-shrink: 0 !important;
    }
}
</style>
